import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  pageHeader: {
    overflow: 'hidden',
  },
  topBackButtonContainer: {
    maxWidth: 1200,
    margin: '0 auto',
    paddingLeft: 20,
    paddingBottom: 11,
    width: '100%',
    [breakpoints.down(1024)]: {
      maxWidth: 640,
    },
  },
  topBackButton: {
    color: palette.primary.main,
    fontWeight: 700,
    lineHeight: '22px',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  backArrow: {
    marginRight: 8,
  },
}));
